__turbopack_context__.v({
  "reviewContent": "ReviewCard-module__dLFEja__reviewContent",
  "reviewFooter": "ReviewCard-module__dLFEja__reviewFooter",
  "reviewImage": "ReviewCard-module__dLFEja__reviewImage",
  "reviewRepeat": "ReviewCard-module__dLFEja__reviewRepeat",
  "reviewStars": "ReviewCard-module__dLFEja__reviewStars",
  "reviewTitle": "ReviewCard-module__dLFEja__reviewTitle",
  "reviewTopRow": "ReviewCard-module__dLFEja__reviewTopRow",
  "root": "ReviewCard-module__dLFEja__root",
});
